// extracted by mini-css-extract-plugin
export default {"days_ago":"ActiveStatusComponent_days_ago__C0Cx1","day":"ActiveStatusComponent_day__-A5FK","inactive":"ActiveStatusComponent_inactive__iKt3u"};